// extracted by mini-css-extract-plugin
module.exports = {"card":"service-card_card__rMK4F","title":"service-card_title__4HuAL","active":"service-card_active__UHUIf","icon":"service-card_icon__s4_2q"};